"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voice-chat.error.noModelOrAvatar': '请选择模型或头像以开始语音对话。',
};
